<template>
    <SideHeader :to="'/'" />
    <div style="padding-top: 55px;">
        <div class="my-2 services pt-3">
            <div class="container">
                <div class="title-header">
                    استعلام ها
                </div>
                <div>
                    <div class="row row-cols-3 text-center justify-content-center">
                        <div class="col service-item">
                            <a href="http://smartcard.rmto.ir/tto/f?p=325:2:16911742336302::NO:RP,2::" target="_blank">
                                <img class="rounded service-img" width="50" src="assets/inquire/estelam-driver.png" alt="" />
                            </a>
                            <p class="mt-1">استعلام کارت هوشمند راننده</p>
                        </div>
                        <div class="col service-item">
                            <a href="http://smartcard.rmto.ir/tto/f?p=325:3:16911742336302::NO:RP,3::" target="_blank">
                                <img class="bg-white rounded  service-img" width="50" src="assets/inquire/estelam-truck.png" alt="" />
                            </a>
                            <p class="mt-1">استعلام کارت هوشمند ناوگان باري</p>
                        </div>
                        <div class="col service-item">
                            <a href="http://smartcard.rmto.ir/tto/f?p=325:4:16911742336302::NO:RP,4::" target="_blank">
                                <img class="bg-white rounded  service-img" width="50" src="assets/inquire/estelam-autobus.png" alt="" />
                            </a>
                            <p class="mt-1">استعلام کارت هوشمند ناوگان مسافري</p>
                        </div>
                        <div class="col service-item">
                            <a href="http://smartcard.rmto.ir/tto/f?p=325:8:16911742336302::NO:RP,8::" target="_blank">
                                <img class="bg-white rounded  service-img" width="50" src="assets/inquire/estelam-health.png" alt="" />
                            </a>
                            <p class="mt-1">استعلام کارت سلامت راننده</p>
                        </div>
                        <div class="col service-item">
                            <a href="http://smartcard.rmto.ir/tto/f?p=325:18:16911742336302::NO:RP,18::" target="_blank">
                                <img class="bg-white rounded  service-img" width="50" src="assets/inquire/estelam-amoozesh.png" alt="" />
                            </a>
                            <p class="mt-1">استعلام دوره هاي آموزشي راننده</p>
                        </div>
                        <div class="col service-item">
                            <a href="http://smartcard.rmto.ir/tto/f?p=326:7:16911742336302::NO:RP::" target="_blank">
                                <img class="bg-white rounded  service-img" width="50" src="assets/inquire/estelam-peymayesh.png" alt="" />
                            </a>
                            <p class="mt-1">استعلام پیمایش ناوگان</p>
                        </div>
                        <div class="col service-item">
                            <a href="https://smartcard.rmto.ir/tto/f?p=325:37:16911742336302::37::" target="_blank">
                                <img class="bg-white rounded  service-img" width="50" src="assets/inquire/trailer-b.png" alt="" />
                            </a>
                            <p class="mt-1">استعلام نیمه یدک</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import SideHeader from '@/components/SideHeader.vue';

export default {
    components: {
        SideHeader
    }
}
</script>
<style scoped>
.title-header {
    color: rgb(77, 77, 77);
    font-weight: 700 !important;
    margin-bottom: 16px;
    padding-bottom: 7px;
    display: block;
    text-align: start;
    color: #4d4d4d;
}
.mt-1{
    font-size: 12px;
    font-weight: 600;
}
</style>